import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

function CategoryList() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Email Form State
  const [emailConfig, setEmailConfig] = useState({ sendEmailFormEnabled: false, messageTopicList: [] });
  const [selectedTopic, setSelectedTopic] = useState('');
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState([]);
  const [emailStatus, setEmailStatus] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetch('/api/config/siteName')
      .then(res => res.json())
      .then(data => {
        document.title = data.siteName;
      })
      .catch(err => console.error(err));
      
    // Fetch Email Config
    fetch('/api/email/config')
      .then(res => res.json())
      .then(data => {
        setEmailConfig(data);
        if (data.messageTopicList && data.messageTopicList.length > 0) {
            setSelectedTopic(data.messageTopicList[0]);
        }
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch('/api/categories');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setCategories(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const handleSendEmail = async (e) => {
      e.preventDefault();
      setIsSending(true);
      setEmailStatus('');

      const formData = new FormData();
      formData.append('topic', selectedTopic);
      formData.append('message', message);
      files.forEach(file => {
          formData.append('files', file);
      });

      try {
          const response = await fetch('/api/email/send', {
              method: 'POST',
              body: formData,
          });

          if (response.ok) {
              setEmailStatus('Email sent successfully!');
              setMessage('');
              setFiles([]);
              if(fileInputRef.current) fileInputRef.current.value = '';
          } else {
              const errText = await response.text();
              setEmailStatus(`Error: ${errText}`);
          }
      } catch (err) {
          setEmailStatus(`Error: ${err.message}`);
      } finally {
          setIsSending(false);
      }
  };

  const pageStyle = {
    minHeight: '100vh',
    backgroundImage: 'url(/moon_banner.jpg)',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    backgroundColor: 'black',
    color: 'gold'
  };

  const contentStyle = {
    padding: 20,
    maxWidth: 900,
    margin: '0 auto'
  };

  const formStyle = {
      marginTop: '40px',
      padding: '20px',
      border: '1px solid gold',
      borderRadius: '8px',
      backgroundColor: 'rgba(0, 0, 0, 0.7)'
  };

  const inputStyle = {
      display: 'block',
      width: '100%',
      marginBottom: '10px',
      padding: '8px',
      boxSizing: 'border-box'
  };

  if (loading) {
    return <div style={pageStyle}><div style={contentStyle}>Loading categories...</div></div>;
  }

  if (error) {
    return <div style={pageStyle}><div style={{...contentStyle, color: 'red'}}>Error: {error}</div></div>;
  }

  return (
    <div style={pageStyle}>
      <div style={contentStyle}>
        <h2 style={{ color: 'gold' }}>Site sections</h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li key='privacy_policy' style={{ marginBottom: 10 }}>
            <a
                href="/privacy_policy"
                style={{ textDecoration: 'none', color: 'gold', fontSize: '18px', fontWeight: 'bold', textShadow: '1px 1px 2px black' }}
            > Privacy Policy
            </a>
          </li>
          {categories.map((category) => (
            <li key={category.id} style={{ marginBottom: 10 }}>
              <Link 
                to={category.onlyArticleId && category.onlyArticleId > 0 
                    ? `/article/${category.onlyArticleId}` 
                    : `/category/${category.id}/${encodeURIComponent(category.title)}`}
                style={{ textDecoration: 'none', color: 'gold', fontSize: '18px', fontWeight: 'bold', textShadow: '1px 1px 2px black' }}
              >
                {category.title}
              </Link>
            </li>
          ))}
          {emailConfig.sendEmailFormEnabled && (
            <li key='write_us' style={{ marginBottom: 10 }}>
              <button 
                  onClick={() => setIsFormVisible(!isFormVisible)}
                  style={{ 
                      background: 'none', 
                      border: 'none', 
                      padding: 0, 
                      color: 'gold', 
                      fontSize: '18px', 
                      fontWeight: 'bold', 
                      textShadow: '1px 1px 2px black', 
                      cursor: 'pointer',
                      textDecoration: 'underline'
                  }}
              >
                  Write US
              </button>
            </li>
          )}
        </ul>

        {emailConfig.sendEmailFormEnabled && isFormVisible && (
            <div style={formStyle}>
                <form onSubmit={handleSendEmail}>
                    <select 
                        style={inputStyle} 
                        value={selectedTopic} 
                        onChange={(e) => setSelectedTopic(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a topic</option>
                        {emailConfig.messageTopicList && emailConfig.messageTopicList.map((topic, index) => (
                            <option key={index} value={topic}>{topic}</option>
                        ))}
                    </select>
                    
                    <textarea 
                        style={{...inputStyle, minHeight: '100px'}} 
                        placeholder="Your message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    />
                    
                    <input 
                        type="file" 
                        multiple 
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        style={{ display: 'block', width: '100%', marginBottom: '10px', color: 'white' }}
                    />
                    
                    <button 
                        type="submit" 
                        disabled={isSending}
                        style={{ padding: '10px 20px', backgroundColor: 'gold', color: 'black', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}
                    >
                        {isSending ? 'Sending...' : 'Send'}
                    </button>
                    {emailStatus && <p style={{ marginTop: '10px', color: emailStatus.startsWith('Error') ? 'red' : 'lightgreen' }}>{emailStatus}</p>}
                </form>
            </div>
        )}
      </div>
    </div>
  );
}

export default CategoryList;
